import { Component, OnInit, OnDestroy } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader'; // <============
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent extends BasePageComponent implements OnInit, OnDestroy {


  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  userName
  orderId
  singleOrderdata
  responseStatus
  OrderDetails = []
  spicerate
  finalSPICE = []
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  userName_loggedin;
  user_Name: any;
  reviewForAllergyForm: FormGroup
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private _snackBar: MatSnackBar,
    private _location: Location) {
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: ''
        }
      ]
    };
  }
  dishID
  orderIdFromParam
  orderItemIdFromParam
  params
  DishName
  ngOnInit() {
    this.route.queryParams.subscribe((p: any) => {
      if (p.filter) {
        this.params = JSON.parse(p.filter);
      }
      this.orderIdFromParam = this.params[0]?.id;
      this.DishName = this.params[0]?.dishname;
      this.orderItemIdFromParam = this.params[0]?.ordItemId
      this.dishID = this.params[0]?.dishId
    });
    // this.DishName = this.route.snapshot.queryParamMap.get('dishname');
    this.restoID = sessionStorage.getItem("restoId");
    this.dishID = sessionStorage.getItem('dishId');

    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.postReviewForm();
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;

  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }
  backTologin() {
    this.router.navigate(['/public/sign-in']);
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          // this.resetFormLoad = false;
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }
  backHomeUser() {
    this.router.navigate(['/horizontal/resto'])
  }
  backHomeGuest() {
    this.router.navigate(['/public/resto'])
  }

  starRatings
  backClicked() {
    this._location.back();
  }
  submitted: boolean = false;
  // Function to post the user reviews
  postUserReviews() {
    this.submitted = true;
    if (this.reviewForAllergyForm.valid) {
      if (this.orderIdFromParam && this.orderItemIdFromParam) {
        let postreviewObj = {
          dish_id: this.dishID,
          restaurant_id: this.restoID,
          order_id: this.orderIdFromParam,
          order_item_id: this.orderItemIdFromParam,
          test_score_code: this.reviewForAllergyForm.value.starRatings,
          test_score_text: this.reviewForAllergyForm.value.tasteScore,
          alleregens_rating_code: this.reviewForAllergyForm.value.safeButton,
          alleregens_rating_text: this.reviewForAllergyForm.value.unSafeTextValue,
        }
        this.httpSv.postUserReviews(postreviewObj).subscribe((res: any) => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open(res.message);
            setTimeout(() => {
              this._snackBar.dismiss();
              this.router.navigate(['/horizontal/food-menu'])
            }, 2000);
          }
          else {
            this._snackBar.open(res.message);
            setTimeout(() => {
              this._snackBar.dismiss();
              this.router.navigate(['/horizontal/food-menu'])
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open(err.error.message);
          setTimeout(() => {
            this._snackBar.dismiss();
            this.router.navigate(['/horizontal/food-menu'])
          }, 2000);
          console.log(err);
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
          console.log(err);
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        })
      } else {
        let postreviewObj = {
          dish_id: this.dishID,
          restaurant_id: this.restoID,
          test_score_code: this.reviewForAllergyForm.value.starRatings,
          test_score_text: this.reviewForAllergyForm.value.tasteScore,
          alleregens_rating_code: this.reviewForAllergyForm.value.safeButton,
          alleregens_rating_text: this.reviewForAllergyForm.value.unSafeTextValue,
        }
        this.httpSv.postDishReviews(postreviewObj).subscribe((res: any) => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open(res.message);
            setTimeout(() => {
              this._snackBar.dismiss();
              this.router.navigate(['/horizontal/food-menu'])
            }, 2000);
          }
          else {
            this._snackBar.open(res.message);
            setTimeout(() => {
              this._snackBar.dismiss();
              this.router.navigate(['/horizontal/food-menu'])
            }, 2000);
          }
        }, (err: any) => {
          this._snackBar.open(err.error.message);
          setTimeout(() => {
            this._snackBar.dismiss();
            this.router.navigate(['/horizontal/food-menu'])
          }, 2000);
          console.log(err);
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        })
      }
    } else {

    }
  }
  safevalue = '0'
  unsafeBool: boolean = false;
  safeClassFlag = false;
  checkUnsafe() {
    this.safevalue = '1'
    this.unsafeBool = true;
    this.safeClassFlag = false;
    console.log(this.safeClassFlag)
    this.reviewForAllergyForm.controls['safeButton'].setValue('Unsafe');
  }
  checkSafe() {
    this.safevalue = '0'
    this.safeClassFlag = true;
    this.unsafeBool = false;
    this.reviewForAllergyForm.controls['safeButton'].setValue('safe');
  }

  postReviewForm() {
    this.reviewForAllergyForm = new FormGroup({
      safeButton: new FormControl('', [Validators.required]),
      unSafeTextValue: new FormControl(''),
      starRatings: new FormControl('', Validators.required),
      tasteScore: new FormControl('')
    })
  }
  get f() {
    return this.reviewForAllergyForm.controls;
  }
}
